import type { TimeseriesDataPoint } from './shared.ts'

export const aiUsageTypes = [
  'chat',
  'document',
  'chat-analysis',
  'chat-aggregation',
  'address-import',
  'automated-auditing',
] as const
export type AiUsageType = (typeof aiUsageTypes)[number]

export type AiUsageTimeseriesResult = TimeseriesDataPoint

export type AiUsageTotalResult = {
  accountId: string
  inputTokens: number
  cachedTokens: number
  outputTokens: number
  thoughtTokens: number
  totalTokens: number
  estimatedCost: number
  chatCost: number
  documentCost: number
  auditingCost: number
}

export type AiUsageChatResult = {
  accountId: string
  totalTokens: number
  totalChats: number
  totalUserMessages: number
  tokenLimit: number
}
